var _g, _g2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "30px",
    width: "30px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    fill: "#ff0000",
    stroke: "#ff0000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ff0000"
    },
    points: "7.533,503.467 502.467,503.467 502.467,8.533 7.533,8.533 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ff0000"
    },
    points: "50.2,460.8 459.8,460.8 459.8,51.2 50.2,51.2 "
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M511,512H-1V0h512V512z M16.067,494.933h477.867V17.067H16.067V494.933z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M468.333,469.333H41.667V42.667h426.667V469.333z M58.733,452.267h392.533V59.733H58.733V452.267z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquare);
export default __webpack_public_path__ + "static/media/square.6d22ad71869201303b245adc7ee52369.svg";
export { ForwardRef as ReactComponent };